import ReactHelmet from 'react-helmet';

interface IProps {
  title: string;
}
export default function Helmet(props: IProps) {
  const { title } = props;
  return (
    <ReactHelmet defer={false}>
      <title>{title}</title>
    </ReactHelmet>
  );
}
